function periodString(date, period) {
  switch (period) {
    case 'month':
      return date.slice(0, 7);
    case 'year':
      return date.slice(0, 4);
    default:
      throw new Error(`Invalid period ${period}`);
  }
}

export default periodString;
